import { Measure } from '@cbsi-cbscom/measure';
import { getLanguageLabelByCode, Language } from 'library/ts/model/language/Language';
import { Cookies } from 'library/ts/utilities/Cookies';
import { LogService } from 'library/ts/utilities/logger/LogService';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { PublicEnums } from 'tag/ts/smart_tag/model/enums/PublicEnums';
import { SmartTagOperations } from 'tag/ts/smart_tag/operations/SmartTagOperations';
import { getSmartTagRuntimeVO } from 'tag/ts/smart_tag/utilities/Runtime';
import { AviaAdapter } from 'tag/ts/tag/player/adapters/avia/AviaAdapter';
import { PlayerAdapterType } from 'tag/ts/tag/player/enums/PlayerAdapterType';
import { Tag } from 'tag/ts/tag/Tag';
export class SmartTag {
    #enums;
    #connectionMonitor;
    #DETECT_AUTOPLAY = true;
    #autoplay;
    deviceCapabilities;
    #runtimeVO;
    #logger;
    #operations;
    #registry = {};
    #list = [];
    constructor(_para = window?.PARA) {
        this.#enums = new PublicEnums();
        this.#logger = LogService.create({ prefixes: ['SmartTag:'] });
        this.#operations = new SmartTagOperations({
            logger: this.#logger,
            utilities: this.utilities,
            capabilities: this.capabilities,
            detectAutoplay: this.#DETECT_AUTOPLAY,
            smartTagInstance: this,
            setConnectionMonitor: (monitor) => {
                this.#connectionMonitor = monitor;
            },
            setAutoplay: (info) => {
                this.#autoplay = info;
            },
            getRegistry: () => this.#registry,
            getList: () => this.#list,
            setList: (list) => {
                this.#list = list;
            },
            setRegistry: (registry) => {
                this.#registry = registry;
            },
            removeFromList: (uuid) => {
                const index = this.utilities?.Array?.indexOf?.('uuid', uuid, this.#list);
                if (index !== null && index !== undefined) {
                    this.#list.splice(index, 1);
                }
            },
            removeFromRegistry: (uuid) => {
                delete this.#registry[uuid];
            }
        });
        if (this.utilities?.Delay?.delay) {
            this.utilities.Delay.delay().then(() => {
                this.#runtimeVO = getSmartTagRuntimeVO();
                this.#logger.log('this.#runtimeVO?.readyCallback?.detectAutoplay', this.#runtimeVO?.readyCallback?.detectAutoplay);
                if (!this.#runtimeVO?.readyCallback?.detectAutoplay) {
                    this.#DETECT_AUTOPLAY = false;
                }
                this.#start();
            }).catch((error) => {
                this.#logger.error('Error during initialization delay:', error);
            });
        }
        else {
            this.#logger.error('Utilities.Delay not available');
        }
    }
    get logger() {
        return this.#logger;
    }
    get DETECT_AUTOPLAY() {
        return this.#DETECT_AUTOPLAY;
    }
    get connectionMonitor() {
        return this.#connectionMonitor;
    }
    set connectionMonitor(value) {
        this.#connectionMonitor = value;
    }
    set autoplay(value) {
        this.#autoplay = value;
    }
    get name() {
        return 'SmartTag';
    }
    get info() {
        return {
            version: window?.PlayerServicesProjectInfo?.release_version || 'unknown',
            date: window?.PlayerServicesProjectInfo?.app_compile_time?.tag?.token || 'unknown'
        };
    }
    get startTime() {
        return window?.PARA?.PlayerServices?.StartTime;
    }
    get utilities() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    get cookies() {
        return Cookies.getInstance();
    }
    get capabilities() {
        return window?.PARA?.PlayerServices?.Capabilities;
    }
    get online() {
        return this.#connectionMonitor !== undefined
            ? this.#connectionMonitor.onLine
            : undefined;
    }
    get autoplay() {
        return this.#autoplay;
    }
    get runtimeVO() {
        return this.#runtimeVO;
    }
    get registry() {
        return this.#registry;
    }
    set registry(value) {
        this.#registry = value;
    }
    get list() {
        return this.#list;
    }
    set list(value) {
        this.#list = value;
    }
    get enums() {
        return this.#enums;
    }
    get Language() {
        return {
            list: Language,
            getLanguageLabelByCode: getLanguageLabelByCode
        };
    }
    get playerAdapters() {
        return {
            [PlayerAdapterType.AVIA]: AviaAdapter
        };
    }
    get performanceMetrics() {
        return Measure?.metrics;
    }
    create = (paramsVO, callbacksVO = {}) => {
        this.#logger.log('create:', paramsVO);
        Measure.end(Metrics.importToCreateTime);
        Measure.start(Metrics.createToLoadTime);
        return new Promise((onReadyResolve, onReadyReject) => {
            const tag = new Tag({
                paramsVO: paramsVO,
                callbacksVO: callbacksVO,
                resolve: onReadyResolve,
                reject: onReadyReject
            });
            this.registry[tag.uuid] = tag;
            if (this.utilities?.Array?.hasObjWithPropValue &&
                this.utilities.Array.hasObjWithPropValue(this.list, 'uuid', tag.uuid) === false) {
                this.list.push(tag);
            }
        });
    };
    remove = (tag) => {
        return this.#operations.removeTag(tag);
    };
    reset = () => {
        return this.#operations.resetTags();
    };
    #start = () => {
        this.#logger.log('Start');
        this.#operations.initializeConnectionMonitor();
        this.#operations.handleAutoplayDetection();
    };
}
